<template>
    <div :class="classNames">
        <div :class="classNames+ '_search'">
            <div>
                <el-button type="primary" @click="createSystemFun" size="small">新建附赠实物</el-button>
                <el-popover width="400" 	placement="top-start"
                    trigger="hover" >
                    <span>添加附赠实物，课程需再次推送抖音课程库审核，审核通过小程序端才会展示附赠实物获取地址功能；若中途想要关闭附赠实物，课程也需再次推送抖音课程库，审核通过小程序附赠实物方可关闭不展示</span>
                    <img slot="reference" class="question" src="http://img-dbzd.doubaozhidao.com/20220815/rAaEw2JCF5WcD7sTaxjMYShkmnARrmM21660554235278.png?x-oss-process=image/quality,q_80/format,png" alt=""/>
                </el-popover>
            </div>
        </div>
        <div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="accountList.data"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}">
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in headerList"
						:type="item.prop" :key="index" :width="item.width">
						<template slot-scope="scope">
                            <el-popover
                                v-if="item.showOverflowTooltip"
                                placement="bottom"
                                title="课程"
                                trigger="click"
                                :popper-class="classNames+'_tip_wrap'"
                                >
                                    <el-scrollbar :class="classNames+'_tip_scroll'">
                                        <ul :class="classNames+'_tip_ul'">
                                            <li v-for="(item, index) in scope.row[item.prop]" :key="index">{{item}}</li>
                                        </ul>
                                    </el-scrollbar>
                                <div slot="reference" class="showOverflowTooltip">{{scope.row[item.prop].join(',')}}</div>
                            </el-popover>
                            <span v-else-if="item.prop === 'send_back_on_refund'">{{ handleRefund(scope.row[item.prop])}}</span>
                            <span v-else-if="item.prop === 'status'">{{ scope.row[item.prop] === 1? '开启': '关闭'}}</span>
                            <span v-else-if="item.prop === 'dy_status'">{{ handleDyStatus(scope.row[item.prop])}}</span>
                            <span v-else-if="item.prop === 'is_force'">{{ scope.row[item.prop] === 1? '强制': '非强制'}}</span>
							<span v-else>{{scope.row[item.prop]}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
                            <span @click="edit(scope.row)" :class="classNames+'_operation_title'" v-if="scope.row.can_edit">编辑</span>
							<span @click="deltes(scope.row)" :class="classNames+'_operation_title'" v-if="scope.row.can_del">删除</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination @change="changeSize" :total="accountList.total" ref="pagination" v-model="searchObj.page" v-if="Math.ceil(accountList.total / accountList.limit) > 1"></Pagination>
		</div>
        <el-dialog
            title=""
            :visible.sync="dialogVisible"
            width="700px"
            :custom-class="classNames + '_dialog'"
            :key="isResetFlag"
            @close="handleClose">
                <div slot="title">
                    <span>{{(id? '编辑': '新建')}}附赠实物</span>
                    <el-popover width="150" 	placement="top-start"
                        trigger="hover" >
                        <span>实物教材最多可添加6个</span>
                        <img slot="reference" class="question" src="http://img-dbzd.doubaozhidao.com/20220815/rAaEw2JCF5WcD7sTaxjMYShkmnARrmM21660554235278.png?x-oss-process=image/quality,q_80/format,png" alt=""/>
                    </el-popover>
                </div>
                <div :class="classNames + '_dialog_content'">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="right" label-width="100px">
                        <el-form-item label="附赠实物" prop="status">
                            <el-radio-group v-model="ruleForm.status">
                                <el-radio :label="item.value" v-for="item in statusList" :key="item.value">{{item.label}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="获取场景" prop="is_force">
                            <el-radio-group v-model="ruleForm.is_force">
                                <el-radio :label="item.value" v-for="item in is_force_list" :key="item.value">{{item.label}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
						<el-form-item label="选择课程" prop="product_ids">
                            <el-select v-model="ruleForm.product_ids" :disabled="!!id">
								<el-option :value="item.id" :label="item.title" v-for="item in productList" :key="item.id">({{item.price}}){{item.title}}</el-option>
							</el-select>
							<span style="font-size: 12px; color: rgb(136, 138, 149); line-height: 17px; margin-left: 12px;margin-top: 10px;">此列表只展示“已入课程库”的课</span>
                        </el-form-item>
						<el-form-item label="退款规则:" prop="send_back_on_refund">
							<span style="font-size: 12px; color: rgb(136, 138, 149); line-height: 17px; margin-top: 10px;">若因课程产生退款需退还附赠实物素材情况，需讲师自行联系用户退回，平台概不负责</span>
                            <el-radio-group v-model="ruleForm.send_back_on_refund">
                                <el-radio :label="item.value" v-for="item in refundList" :key="item.value">{{item.label}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
					<ul :class="classNames+ '_address_ul'">
						<li v-for="(item, index) in ruleForm.goods_img" :key="index">
							<div class="li-con el-form-item" :class="{'is-error': !item.name}">
								<span><span style="color:#F56C6C;margin-right: 4px">*</span>实物名称</span>
								<el-input v-model="item.name" placeholder="请输入实物名称" maxlength="8" show-word-limit></el-input>
							</div>
							<div lass="li-con">
								<span><span style="color:#F56C6C;margin-right: 4px">*</span>实物图片</span>
								<uploadImg v-model="item.img" :item="{width: 100,height: 100,}" style="display:inline-block" :style="{'border': item.img? '': '1px solid red'}" :is_material="false"></uploadImg>
								<span>建议尺寸：100*100</span>
							</div>
							<div class="opeartion">
								<span v-if="ruleForm.goods_img.length - 1 === index && ruleForm.goods_img.length < 6" @click="addGoodsimg">添加</span>
								<span v-if="ruleForm.goods_img.length> 1" @click="deleteGoodsimg(index)">删除</span>
							</div>
						</li>
					</ul>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addCancel('ruleForm')">取 消</el-button>
                    <el-button type="primary" @click="addSure('ruleForm')">确 定</el-button>
                </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import Pagination from '@/components/pagination/pagination.vue'
import uploadImg from '@/pages/qualifications/uploadImgItem.vue'
export default {
    data() {
        return {
            classNames: 'dygettingUserInformation',
            searchObj: {
                name: '',
                account: '',
                limit: 10,
                page: 1
            },
            headerList: [
                {
					prop: 'id',
					label: 'id',
                    width: 100,
				},
                {
					prop: 'preserve_product_title',
					label: '课程信息',
                    showOverflowTooltip: true,
                    width: 260
				},
				{
					prop: 'send_back_on_refund',
					label: '退款规则'
				},
                {
					prop: 'status',
					label: '状态'
				},
                {
					prop: 'is_force',
					label: '获取场景'
				},
				{
					prop: 'dy_status',
					label: '抖音状态',
                    width: 200
				}
            ],
            accountList: {
                data: [],
                total: 0
            },
            noDataName: 'empty',
            dialogVisible: false,
            ruleForm: {
                status: 1,
                preserve_method: 2,
                is_force: 1,
                product_ids: '',
                send_back_on_refund: '',
                goods_img: [
                    {
                        name: '',
                        img: ''
                    }
                ]
            },
            rules: {
                send_back_on_refund: [
                    { required: true, message: '请选择退款规则', trigger: 'change' }
                ],
                product_ids: [
                    { required: true, message: '请选择课程', trigger: 'change' }
                ]
            },
            statusList: [
                {
                    label: '开启',
                    value: 1
                },
                {
                    label: '关闭',
                    value: 2
                }
            ],
            is_force_list: [
                {
                    label: '强制',
                    value: 1
                },
                {
                    label: '非强制',
                    value: 2
                }
            ],
            refundList: [
               {
                    label: '课程产生退款，附赠实物可不退还',
                    value: 0
                },
                {
                    label: '课程产生退款，需退还附赠实物',
                    value: 1
                }
            ],
            isResetFlag: false,
            id: '',
            productList: []
        }
    },
    created() {
        this.preserveMethodListFun()
        this.$watch(() => this.dialogVisible, (news) => {
            console.log(news, '====')
            if(news) {
                this.getPreserveProducts()
            }
        })
    },
    computed: {
        isDyFlag() {
            return this.staticPath === '/'
        }
    },
    components: {
        Pagination,
        uploadImg
    },
    methods: {
        ...mapActions('cusomer', ['addPreserveMethod', 'preserveMethodList', 'editPreserveMethod', 'preserveMethodInfo', 'removePreserveMethod', 'preserveProducts']),
        createSystemFun() {
            this.dialogVisible = true
        },
        changeSize(size) {
            this.searchObj.page = size
            // this.getAccountListFun()
        },
        async preserveMethodListFun(flag) {
            if(flag) {
                this.searchObj.page = 1
            }
            let res = await this.preserveMethodList(this.searchObj)
            this.accountList = res
            console.log('this.accountList:',this.accountList)
        },
        edit(row) {
            this.dialogVisible = true
            this.id = row.id
            this.detailInfo()
        },
        async detailInfo() {
            let res = await this.preserveMethodInfo({id: this.id})
            for (const key in this.ruleForm) {
                if(key === 'goods_img') {
                    this.ruleForm[key] = res[key].length ? res[key]: [
                        {
                            name: '',
                            img: ''
                        }
                    ]
                } else if(key == 'product_ids') {
                    this.ruleForm[key] = res[key][0]
                } else {
                    this.ruleForm[key] = res[key]
                }
            }
            console.log(this.ruleForm)
        },
        async deltes(row) {
           this.$confirm('确定要删除吗？', '信息', {
                distinguishCancelAndClose: false,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: this.classNames + '_common_dialog',
                center: true
            })
            .then(async() => {
                try {
                    await this.removePreserveMethod({id: row.id})
                    this.preserveMethodListFun()
                    this.$message(
                        {
                            type: 'success',
                            message: '删除成功',
                            duration: 3000
                        }
                    )
                } catch (error) {
                    
                }
            })
        },
        search() {
            this.noDataName = 'noData'
            this.getAccountListFun(true)
        },
        addSure(name) {
            this.$refs[name].validate(async (valid) => {
                let flag = this.ruleForm.goods_img.every(item => item.name && item.img)
                let params = {
                    ...this.ruleForm,
                    product_ids: [this.ruleForm.product_ids]
                }
                if(valid && flag) {
                    if(this.id) {
                        await this.editPreserveMethod({id: this.id, ...params})
                        this.preserveMethodListFun()
                    } else {
                        await this.addPreserveMethod(params)
                        this.preserveMethodListFun(true)
                    }
                    this.resetFun(name)
                    this.dialogVisible = false
                    this.$message({
                        type: 'success',
                        message: (this.id? '修改' : '新建') + '成功',
                        duration: 3000
                    })
                }
            })
        },
        handleClose() {
            if(this.id) {
                this.resetFun('ruleForm')
            }
            // if(this.id) {
            //     this.resetFun('ruleForm')
            // }
            this.id = ''
        },
        addCancel(name) {
            this.dialogVisible = false
            this.resetFun(name)
        },
        resetFun(name) {
            this.$refs[name].resetFields()
            this.ruleForm = {
                status: 1,
                preserve_method: 2,
                is_force: 1,
                product_ids: '',
                send_back_on_refund: '',
                goods_img: [
                    {
                        name: '',
                        img: ''
                    }
                ]
            }
        },
        addGoodsimg() {
            this.ruleForm.goods_img.push({
                name: '',
                img: ''
            })
        },
        deleteGoodsimg(index) {
            this.ruleForm.goods_img.splice(index, 1)
        },
        async getPreserveProducts() {
            let res  = await this.preserveProducts(this.id ? {method_id: this.id}: {})
            this.productList = res
        },
        handleDyStatus(status) {
            const dyStatusList = {
                1:'待审核',
                2: '审核中',
                3: '审核通过',
                4: '审核驳回'
            }
            return dyStatusList[status] || ''
        },
        handleRefund(status) {
            let obj = this.refundList.find(item => item.value === status)
            return obj ? obj.label : ''
        }
    }
}
</script>
<style lang="less">
@classNames: dygettingUserInformation;
.@{classNames}_operation_title {
    margin-right: 12px;
    color: #1989FA;
    font-size: 14px;
    cursor: pointer;
}
.@{classNames}_dialog {
    .el-dialog__header {
        padding: 12px 24px;
    }
    .el-dialog__body {
        padding: 12px 24px;
        // .el-form-item__label {
        //     line-height: 18px;
        // }
    }
    .@{classNames}_list {
        display: flex;
        justify-content: space-between;
        .gettingList {
            width: 46%;
        }
    }
}
.@{classNames}_tip_wrap {
    .@{classNames}_tip_scroll {
        max-height: 300px;
        display: flex;
        flex-direction: column;
    }
    .@{classNames}_tip_ul {
        li {
            list-style: none;
            padding: 6px 0;
        }
    }
}
</style>
<style lang="less" scoped>
    @classNames: dygettingUserInformation;
    .question {
        display: inline-block;
        position: relative;
        left: 5px;
        top: 0px;
        width: 17px;
        height: 17px;
        margin-right: 10px;
    }
    .@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;
        .showOverflowTooltip {
            overflow: hidden;
            white-space:nowrap;
            text-overflow: ellipsis
        }
        .el-table::before {
			background-color: transparent;
		}
		.@{classNames}_search {
			display: flex;
			justify-content: space-between;
			margin-bottom: 40px;
			flex-shrink: 0;

			.@{classNames}_search_con {
				display: flex;

				.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					margin-right: 16px;

					.@{classNames}_search_con_item_title {
						white-space: nowrap;
						font-size: 14px;
						color: #606266;
						margin-right: 12px;
					}
				}
			}
		}
		.@{classNames}_con {
			flex: 1;
			display: flex;
			flex-direction: column;
		}
	}
    .@{classNames}_address_ul {
        li {
            list-style: none;
            display: flex;
            flex-direction: column;
            width: 500px;
            box-shadow: 0 0 6px rgba(0,0,0,0.5);
            padding: 8px;
            box-sizing: border-box;
            border-radius: 6px;
            &:not(:first-child) {
                margin-top: 12px;
            }
            >div{
                display: flex;
                span {
                    line-height: 30px;
                    white-space: nowrap;
                    margin-right: 12px;
                }
                &:not(:last-child) {
                    margin-bottom: 12px;
                }
            }
            .opeartion {
                display: flex;
                justify-content: flex-end;
                span {
                    color: #409EFF;
                    cursor: pointer;
                }
            }
        }
    }
</style>
